import { render, staticRenderFns } from "./AccountingDocList.vue?vue&type=template&id=c5809cea&"
import script from "./AccountingDocList.vue?vue&type=script&lang=js&"
export * from "./AccountingDocList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports